"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'Integrations',
  props: ['user'],
  data() {
    return {
      integrations: [{
        name: 'Google Calendar',
        description: 'Sincroniza tus eventos y citas con tus fans.',
        icon: 'fa-calendar',
        color: '#4285F4',
        connected: false
      }, {
        name: 'Telegram',
        description: 'Bot oficial: Conecta para recibir notificaciones y comandos en tiempo real.',
        icon: 'fa-paper-plane',
        color: '#0088cc',
        connected: false
      }, {
        name: 'Discord',
        description: 'Conecta con tu servidor de Discord para roles VIP.',
        icon: 'fa-comments',
        color: '#5865F2',
        connected: false
      }, {
        name: 'Twitter (X)',
        description: 'Publica automáticamente actualizaciones de tu perfil.',
        icon: 'fa-twitter',
        color: '#1DA1F2',
        connected: false
      }, {
        name: 'WhatsApp',
        description: 'Recibe consultas directas de tus suscriptores.',
        icon: 'fa-whatsapp',
        color: '#25D366',
        connected: false
      }, {
        name: 'Instagram',
        description: 'Comparte tus mejores momentos e historias.',
        icon: 'fa-instagram',
        color: '#E4405F',
        connected: false
      }, {
        name: 'Threads',
        description: 'Mantén el contacto mediante hilos y comunidad.',
        icon: 'fa-at',
        color: '#000000',
        connected: false
      }, {
        name: 'TikTok',
        description: 'Sincroniza tus videos cortos y tendencias.',
        icon: 'fa-music',
        color: '#000000',
        connected: false
      }, {
        name: 'Google Account',
        description: 'Inicia sesión y sincroniza datos con tu cuenta principal.',
        icon: 'fa-google',
        color: '#4285F4',
        connected: false
      }, {
        name: 'Auth0',
        description: 'Autenticación segura multi-plataforma y Single Sign-On.',
        icon: 'fa-lock',
        color: '#EB5424',
        connected: false
      }]
    };
  },
  mounted() {
    this.checkAuthStatus();
  },
  methods: {
    loadTelegramWidget() {
      // Configuración del Bot oficial
      const BOT_USERNAME = 'im_verify_bot'; // Cambiar por tu username real
      const CALLBACK_URL = 'https://imverify.online/auth/telegram/callback'; // Backend servidor

      const container = document.getElementById('telegram-login-container');
      if (container) {
        container.innerHTML = '';
        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-widget.js?22';
        script.setAttribute('data-telegram-login', BOT_USERNAME);
        script.setAttribute('data-size', 'large');
        script.setAttribute('data-auth-url', CALLBACK_URL);
        script.setAttribute('data-request-access', 'write');
        script.async = true;
        container.appendChild(script);
      }
    },
    handleConnect(item) {
      if (item.name === 'Discord') {
        this.loadDiscordAuth();
      } else if (item.name === 'Twitter (X)') {
        this.loadTwitterAuth();
      } else if (item.name === 'Auth0') {
        this.loadAuth0Auth();
      } else {
        this.toggleIntegration(item);
      }
    },
    loadDiscordAuth() {
      // Client ID real de Discord proporcionado
      const CLIENT_ID = '1488253162035876002';
      const REDIRECT_URI = encodeURIComponent('https://imverify.online/auth/discord/callback');
      const SCOPE = 'identify';
      const STATE = encodeURIComponent(this.user ? this.user.handle : 'guest');
      const authUrl = `https://discord.com/api/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${SCOPE}&state=${STATE}`;

      // Volver a la misma ventana como pidió el usuario
      window.location.href = authUrl;
    },
    async loadTwitterAuth() {
      const CLIENT_ID = 'UnE0UjdNdVZJNUFhSmZDSGFDS2U6MTpjaQ';
      const REDIRECT_URI = encodeURIComponent('https://imverify.online/auth/x/callback');
      const SCOPE = encodeURIComponent('tweet.read users.read offline.access');

      // --- GENERACIÓN DE PKCE S256 ---
      // Generar un verifier aleatorio
      const array = new Uint8Array(32);
      window.crypto.getRandomValues(array);
      const VERIFIER = btoa(String.fromCharCode(...array)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

      // Generar el challenge (SHA-256 del verifier)
      const encoder = new TextEncoder();
      const data = encoder.encode(VERIFIER);
      const hash = await window.crypto.subtle.digest('SHA-256', data);
      const CHALLENGE = btoa(String.fromCharCode(...new Uint8Array(hash))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      const STATE = encodeURIComponent(`${this.user ? this.user.handle : 'guest'}:${VERIFIER}`);
      const authUrl = `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${SCOPE}&state=${STATE}&code_challenge=${CHALLENGE}&code_challenge_method=S256`;
      window.location.href = authUrl;
    },
    loadAuth0Auth() {
      // Reemplazar con tus credenciales reales o inyectar desde config
      const DOMAIN = 'diggitaly.us.auth0.com';
      const CLIENT_ID = 'UpjQ3c9IHOTJkKNtaKejsAZesyos1dyV';
      const REDIRECT_URI = encodeURIComponent('https://imverify.online/auth/auth0/callback');
      const SCOPE = encodeURIComponent('openid profile email');
      const STATE = encodeURIComponent(this.user ? this.user.handle : 'guest');
      const authUrl = `https://${DOMAIN}/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${SCOPE}&state=${STATE}`;
      window.location.href = authUrl;
    },
    toggleIntegration(item) {
      item.connected = !item.connected;
      this.$forceUpdate();
    },
    checkAuthStatus() {
      const params = new URLSearchParams(window.location.hash.split('?')[1]);
      const auth = params.get('auth');
      const platform = params.get('platform');
      if (auth === 'success' && platform) {
        const nameMap = {
          'discord': 'Discord',
          'telegram': 'Telegram',
          'twitter': 'Twitter (X)',
          'auth0': 'Auth0'
        };
        const platformName = nameMap[platform];
        const item = this.integrations.find(i => i.name === platformName);
        if (item) {
          item.connected = true;
          // Limpiar URL
          window.history.replaceState({}, document.title, window.location.pathname + window.location.hash.split('?')[0]);
        }
      }
    }
  }
};